module.exports = __webpack_public_path__ + "static/media/gippsland-tafe.7f757230.png";